import { ListFilter } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const FilterIcon = createLucideIcon(ListFilter);
